<div class="note-card">
  <app-section-card [name]="title" [contentPadding]="[0, 0]">
    <ng-template #actions>
      <ng-container [ngSwitch]="entityType">
        <ng-container *ngSwitchCase="0">
          <p-button *abpPermission="'GCM.Note.Create && GCM.Matter.Edit'" icon="pi pi-plus" (onClick)="showAddNoteDialog()" />
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <p-button *abpPermission="'GCM.Note.Create && GCM.ForeignNational.Edit'" icon="pi pi-plus" (onClick)="showAddNoteDialog()" />
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <p-button *abpPermission="'GCM.Note.Create && GCM.Company.Edit'" icon="pi pi-plus" (onClick)="showAddNoteDialog()" />
        </ng-container>
      </ng-container>
    </ng-template>

    <div class="matter-notes">
      <ng-container *ngIf="!loading; else loadingTpl">
        <ng-container *ngIf="notes.length > 0; else noDataTpl">
          <div class="note-item" *ngFor="let note of notes; let first = first">
            <div class="note-header align-items-center">
              <div class="note-info flex gap-3 align-items-center">
                <span class="author">{{ note.lastModifiedBy || note.createdBy || 'Unknown' }}</span>
                <span class="date">{{ (note.lastModifiedBy ? note.lastModificationTime : note.creationTime) | ptDate : "MMM DD, YYYY" }}</span>
              </div>
              <div class="note-actions">
                <ng-container [ngSwitch]="entityType">
                  <ng-container *ngSwitchCase="EntityType.Matter">
                    <ng-container *ngIf="first && isNoteCreatorOrManager(note.creatorId)">
                      <p-button *abpPermission="'GCM.Note.Edit && GCM.Matter.Edit'" icon="pi pi-pencil" styleClass="p-button-sm p-button-text p-button-rounded note-edit-btn" (onClick)="editNote(note)" />
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="EntityType.ForeignNational">
                    <ng-container *ngIf="first && isNoteCreatorOrManager(note.creatorId)">
                      <p-button *abpPermission="'GCM.Note.Edit && GCM.ForeignNational.Edit'" icon="pi pi-pencil" styleClass="p-button-sm p-button-text p-button-rounded note-edit-btn" (onClick)="editNote(note)" />
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
            <div class="note-content" [pTooltip]="note.content || 'No content'" tooltipPosition="left" appendTo="body" escape="false" [innerHTML]="(note.content || '<em>No content</em>') | safeHtml"></div>
          </div>

          <div class="footer flex justify-content-end">
            <p-button label="View More" (onClick)="showDialog()"></p-button>
          </div>
        </ng-container>

        <ng-template #noDataTpl>
          <div class="no-data">No notes found.</div>
        </ng-template>
      </ng-container>

      <ng-template #loadingTpl>
        <div class="note-item" *ngFor="let i of [1, 2]">
          <div class="note-header">
            <p-skeleton width="120px" height="17px"></p-skeleton>
            <p-skeleton width="100px" height="14px"></p-skeleton>
          </div>
          <div class="note-content">
            <p-skeleton width="100%" height="40px"></p-skeleton>
          </div>
        </div>
      </ng-template>
    </div>
  </app-section-card>
</div>

<p-dialog [header]="title" [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }" (onShow)="onDialogShow()" (onHide)="onDialogHide()">
  <div class="matter-notes-dialog">
    <ng-container *ngIf="!loadingAll; else loadingAllTpl">
      <div class="note-item" *ngFor="let note of allNotes">
        <div class="note-header">
          <div class="note-info">
            <span class="author">{{ note.lastModifiedBy || note.createdBy || 'Unknown' }}</span>
            <span class="date">{{ (note.lastModifiedBy ? note.lastModificationTime : note.creationTime) | ptDate : "MMM DD, YYYY" }}</span>
          </div>
          <div class="note-actions">
            <ng-container [ngSwitch]="entityType">
              <ng-container *ngSwitchCase="EntityType.Matter">
                <ng-container *ngIf="isNoteCreatorOrManager(note.creatorId)">
                  <p-button *abpPermission="'GCM.Note.Edit && GCM.Matter.Edit'" icon="pi pi-pencil" styleClass="p-button-sm" (onClick)="editNote(note)" />
                  <p-button *abpPermission="'GCM.Note.Delete && GCM.Matter.Edit'" icon="pi pi-trash" styleClass="p-button-sm p-button-danger" (onClick)="deleteNote(note.id)" />
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="EntityType.ForeignNational">
                <ng-container *ngIf="isNoteCreatorOrManager(note.creatorId)">
                  <p-button *abpPermission="'GCM.Note.Edit && GCM.ForeignNational.Edit'" icon="pi pi-pencil" styleClass="p-button-sm" (onClick)="editNote(note)" />
                  <p-button *abpPermission="'GCM.Note.Edit && GCM.Note.Delete'" icon="pi pi-trash" styleClass="p-button-sm p-button-danger" (onClick)="deleteNote(note.id)" />
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="EntityType.Company">
                <ng-container *ngIf="isNoteCreatorOrManager(note.creatorId)">
                  <p-button *abpPermission="'GCM.Note.Edit && GCM.Company.Edit'" icon="pi pi-pencil" styleClass="p-button-sm" (onClick)="editNote(note)" />
                  <p-button *abpPermission="'GCM.Note.Delete && GCM.Company.Edit'" icon="pi pi-trash" styleClass="p-button-sm p-button-danger" (onClick)="deleteNote(note.id)" />
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="note-content-full" [innerHTML]="(note.content || '<em>No content</em>') | safeHtml"></div>
      </div>
    </ng-container>

    <ng-template #loadingAllTpl>
      <div class="note-item" *ngFor="let i of [1, 2, 3, 4]">
        <div class="note-header">
          <p-skeleton width="120px" height="17px"></p-skeleton>
          <p-skeleton width="100px" height="14px"></p-skeleton>
        </div>
        <div class="note-content">
          <p-skeleton width="100%" height="40px"></p-skeleton>
        </div>
      </div>
    </ng-template>
  </div>
</p-dialog>

<p-dialog header="Add Note" [(visible)]="showAddNote" [modal]="true" [style]="{ width: '40vw' }" (onShow)="onDialogShow()" (onHide)="onDialogHide()">
  <div class="add-note-form">
    <p-editor [(ngModel)]="newNote" [style]="{ height: '220px' }" [formats]="['bold', 'italic', 'underline']">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button class="ql-bold" aria-label="Bold"></button>
          <button class="ql-italic" aria-label="Italic"></button>
          <button class="ql-underline" aria-label="Underline"></button>
        </span>
      </ng-template>
    </p-editor>
  </div>
  <ng-template pTemplate="footer">
    <p-button *abpPermission="'GCM.Note.Create'" label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="showAddNote = false"></p-button>
    <p-button *abpPermission="'GCM.Note.Create'" label="Save" icon="pi pi-save" (onClick)="saveNote()" [disabled]="!newNote || isSaving" [loading]="isSaving"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="Edit Note" [(visible)]="showEditNote" [modal]="true" [style]="{ width: '40vw' }">
  <div class="add-note-form">
    <p-editor [(ngModel)]="newNote" [style]="{ height: '220px' }" [formats]="['bold', 'italic', 'underline']">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button class="ql-bold" aria-label="Bold"></button>
          <button class="ql-italic" aria-label="Italic"></button>
          <button class="ql-underline" aria-label="Underline"></button>
        </span>
      </ng-template>
    </p-editor>
  </div>
  <ng-template pTemplate="footer">
    <p-button *abpPermission="'GCM.Note.Edit'" label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="showEditNote = false"></p-button>
    <p-button *abpPermission="'GCM.Note.Edit'" label="Save" icon="pi pi-save" (onClick)="updateNote()" [disabled]="!newNote || isSaving" [loading]="isSaving"></p-button>
  </ng-template>
</p-dialog>
